import { useEffect } from 'react'

import { useExperimentsContext } from '../components/ExperimentsContext'
import { EXPERIMENT_NAME_AD_SERVER_TOP_ALGOLIA_RESULTS } from '../model/EXPERIMENT_NAME'
import { experimentAccessorIsAdServerEnabled } from '../model/experimentAccessor'

export const useExperimentAdServerSerpTopResults = (): void => {
  const { addExperimentKeysForActivation, experiments } =
    useExperimentsContext()
  const isAdServerEnabled = experimentAccessorIsAdServerEnabled(experiments)

  useEffect(() => {
    if (isAdServerEnabled) {
      addExperimentKeysForActivation(
        EXPERIMENT_NAME_AD_SERVER_TOP_ALGOLIA_RESULTS,
      )
    }
  }, [addExperimentKeysForActivation, isAdServerEnabled])
}
